import { NumberInput, NumberInputField } from '@chakra-ui/react';

const BORDER_RADIUS = 99;
const BOX_SHADOW = '0px 4px 64px 0px #0000001A';

const TextInput = ({ fontSize = 16, step, ...rest }) => {
  return (
    <NumberInput borderRadius={BORDER_RADIUS} step={step} allowMouseWheel width={'100%'} {...rest}>
      <NumberInputField
        _focusWithin={{
          borderWidth: 2,
          borderStyle: 'solid',
          boxShadow: BOX_SHADOW,
        }}
        fontSize={fontSize}
        bg="white"
        height={16}
        border="none"
        boxShadow={BOX_SHADOW}
        borderRadius={BORDER_RADIUS}
      />
    </NumberInput>
  );
};

export default TextInput;
